import ChipPeriodType from '@/components/chip/ChipPeriodType';
import type { StatusChipProps } from '@/components/chip/ChipTicketStatus';
import { PeriodTypeEnum } from '@/types/enums/period-type.enum';
import { t } from '@/utils/lang';

export const getPeriodTypeData = (props: StatusChipProps) => {
    return ChipPeriodType(props);
};

export const getPeriodTypeOptionsFilter = (isFilter?: boolean) => {
    const enumValues = PeriodTypeEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getPeriodTypeData({
            status: enumValues[key],
            showChip: false,
        });

        options.push({
            id: enumValues[key],
            value: !isFilter ? enumValues[key] : key.toUpperCase(),
            title: data.label,
            label: t(data.label),
        });
    });

    return options;
};
